import React, { useEffect } from "react";
import upArrow from "../../../asset/images/up-arrow.svg";
import downArrow from "../../../asset/images/down-arrow-red.svg";
import Loader from "../../Common/Loader";
import { aboveOneLacs, forToFix, numDifferentiationWithoutSymbol } from "../../../CommonMethhods/CovertRupees";
import { formatNumber } from "../../../CommonMethhods/CommonMethods";


function PartnerSideSnapshot(props) {
  const title = props.title;
  const dataTarget = props.dataTarget;
  const snapshotData = props.snapshotData;
  const snapshotTotal = snapshotData?.currentCount;
  const snapshotDiffValue = snapshotData?.countDiff;
  const snapshotPercentage = snapshotData?.percentageChange;
  // const snapshotDiffPercentage = snapshotOverall !== 0 ? snapshotOverall/snapshotDiffValue*100 : 0;

  const ChartEq = props.chartEq;
  const ChartFno = props.chartFno;
  const ChartTotal = props.chartTotal;
  const forChartEqPercent = (ChartEq / ChartTotal) * 100;
  const forChartFnoPercent = (ChartFno / ChartTotal) * 100;
  let Overall;
  let DiffValue;

  const loader = props.loader;
  const textCheck =
    title === "MTF Book"
      ? "MTF Book as of Today"
      : title === "Total Paid Accounts" ? 
      "Total Paid clients"
      : "Total " + title.split(" ")[1];

  const time = props.businessFilter;

  const duration = time.split("l")[0];


  if (props.isActive === true) {
    {
      Overall =
      snapshotTotal === undefined || null
          ? "0"
          : formatNumber(snapshotTotal);
      DiffValue =
        snapshotDiffValue === undefined || null
          ? "0"
          : snapshotDiffValue
    }
  } else {
    Overall = snapshotTotal === undefined || null ? "0" : snapshotTotal;
    DiffValue =
      snapshotDiffValue === undefined || null ? "0" : snapshotDiffValue;
  }



  const showSnaphotData = () => {
    return (
      <>
        <div className="block1-data">
          <div className="block1-data-display">
            {/* snapshot overall value */}
            <div className="overall-snap-value business-partner-total">
            <h2>{Overall}</h2>
              </div>
              <div className="overall-snap-value business-partner-total">
              <h3
                className={
                  snapshotDiffValue === 0 || undefined
                    ? "text-muted"
                    : snapshotDiffValue < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                {snapshotDiffValue === 0 || undefined ? null : snapshotDiffValue < 0 ? (
                  <img src={downArrow} alt="Down Arrow" />
                ) : (
                  <img src={upArrow} alt="Up Arrow" />
                )}

                {/* snapshot difference value */}
                <b>{DiffValue}</b>
                
              </h3>
              <h3
                className={
                  
                  snapshotPercentage === 0
                    ? "text-muted"
                    : snapshotPercentage < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                (
                {isNaN(snapshotPercentage) !== true ?
                  snapshotPercentage === undefined || null
                    ? "0"
                    : forToFix(snapshotPercentage) + "%"
                  : "0.00"
                }
                )
              </h3>
              </div>

            <h4>{textCheck}</h4>
          </div>
          {/* <p>
            {props.textfield}
          </p> */}
        </div>
      </>
    );
  };
  return (
    <>
      <div className="col-md-6 col-lg-3">
        <div className="block1 partner-block1">
          <div className="card-subtitle" id="flush-headingOne">
            <h3>{title}</h3>
            {/* add button to open snaphot table  + -  */}
            {/* <div
              className="accordion-button toggle-btn"
              type="button"
              data-toggle="collapse"
              data-target={dataTarget}
              aria-expanded="false"
              aria-controls="flush-collapseOne"
              // onClick={handleSnaphotTable}
            ></div> */}
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            showSnaphotData()
          )}
        </div>
      </div>
    </>
  );
}

export default PartnerSideSnapshot;
